import React, { useState } from "react";
import {
  View,
  TextInput,
  FlatList,
  Text,
  ActivityIndicator,
  TouchableOpacity,
  StyleSheet,
  Modal,
  ScrollView,
} from "react-native";
import { useDebounce } from "use-debounce";

import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import { observer, Observer } from "mobx-react";
import Colors from "../../../Resources/Color";
import { useTranslation } from "react-i18next";
import { useDevice, useScreenDimensions } from "../../_layout";
import SearchBar from "../../Components/SearchBar";
import CTAButton from "../../Components/CTAButton";
import GlobalStyles from "../../../Resources/Styles";
import AddNutritionPlanView from "../../NutritionPlan/AddNutritionPlanView";

import { Menu, MenuItem } from "react-native-material-menu";
import { formatNumber } from "../../utils/numberUtils";

import { FontAwesome5 } from "@expo/vector-icons";
import { Octicons } from "@expo/vector-icons";
import { Entypo } from "@expo/vector-icons";
import ClientWeekStatusText from "../../Components/ClientWeekStatusText";
import Fonts from "../../../Resources/Fonts";
import CustomActivityIndicator from "../../Components/CustomActivityIndicator";
import CustomAlert from "../../Components/CustomAlert";

const CoachNutritionPlanLibrary = ({ coach }) => {
  const { t, i18n } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const [text, setText] = useState("");

  const [showingAddNutritionPlan, setShowingAddNutritionPlan] = useState(false);

  const CopyNutritionPlanToClient = ({ isVisible, onClose, nutritionPlan }) => {
    const [selectedClients, setSelectedClients] = useState([]);

    const [notBlocked, setNotBlocked] = useState([]);

    function toggleVariable() {
      setNotBlocked();

      setTimeout(() => {
        setNotBlocked(true);
        onClose();
      }, 2500);
    }

    const SearchBar = () => {
      const [keyword, setKeyword] = useState("");
      const onChangeText = (text) => {
        setKeyword(text);
        nutritionPlan.coach.setSearchTerm(text);
      };

      const [isHovered, setIsHovered] = useState(false);

      return (
        <View
          style={{
            flexDirection: "row",
            width: "100%",
            justifyContent: "center",
            paddingHorizontal: 20,
            marginTop: 20,
            marginBottom: 10,
          }}
        >
          <View
            style={[
              styles.searchBar,
              {
                backgroundColor: "transparent",
                flex: 1,
                borderWidth: 0.2,
                borderColor: isHovered
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
              },
            ]}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <Octicons name="search" size={20} color={Colors.grayColor} />
            <TextInput
              value={keyword}
              onChangeText={onChangeText}
              style={[
                styles.textInputStyle,
                { color: Colors.blackColor, outline: "none", width: "100%" },
              ]}
              placeholder={t("searchClient-string")}
              placeholderTextColor={Colors.grayColor}
              disabled={!notBlocked}
              maxLength={100}
            />
          </View>
          <Buttons bool={false} />
          <Buttons bool={true} />
        </View>
      );
    };

    const ClientRow = observer(({ client, index }) => {
      const isSelected = selectedClients.includes(client.id);
      const length = nutritionPlan.coach
        .getFilteredClients()
        .filter((client) => client.status === "active-string").length;
      const select = () => {
        if (isSelected) {
          // Append the client's userId to the array
          setSelectedClients((prevSelectedClients) =>
            prevSelectedClients.filter((id) => id !== client.id)
          );
        } else {
          // Remove the client's userId from the array
          setSelectedClients((prevSelectedClients) => [
            ...prevSelectedClients,
            client.id,
          ]);
        }
        nutritionPlan.coach.setSearchTerm("");
      };

      const [isHovered, setIsHovered] = useState(false);

      return (
        <View
          style={{
            flexDirection: "row",
            flex: 1,
            //marginTop: 20,
            padding: 5,
            paddingHorizontal: 16,

            alignItems: "center",
            // borderRadius: 12,
            backgroundColor: isSelected ? Colors.bubbleColor : "transparent",
            paddingVertical: 8,

            borderBottomLeftRadius: index === length - 1 ? 14 : 0,
            borderBottomRightRadius: index === length - 1 ? 14 : 0,

            opacity: isHovered ? 0.9 : 1,
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <TouchableOpacity
            onPress={select}
            style={{ flex: 1 }}
            disabled={!notBlocked}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <View
                style={{
                  alignItems: "flex-start",
                  // marginHorizontal: 10,
                  width: "100%",
                  paddingLeft: isHovered ? 5 : 0,
                }}
              >
                <Text
                  style={{
                    color: isSelected ? Colors.whiteColor : Colors.blackColor,
                    fontSize: 16,
                    fontWeight: isHovered ? "600" : "normal",
                  }}
                >
                  {client.nameForCoach} {client.surnameForCoach}
                </Text>
                <ClientWeekStatusText
                  client={client}
                  style={{
                    color: isSelected
                      ? Colors.lightGrayColor
                      : Colors.grayColor,
                    fontSize: 12,
                    marginTop: 2,
                  }}
                  showColorForUnprepared={isSelected ? false : true}
                />
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            />
            <View
              style={{
                //height: selectedClientName === client.name ? 2 : 1,
                backgroundColor: Colors.grayColor,
                // marginTop: 5,
              }}
            />
          </TouchableOpacity>
        </View>
      );
    });

    const Cancel = () => {
      nutritionPlan.coach.setSearchTerm("");
      onClose();
    };
    const Buttons = ({ bool }) => {
      const text = bool ? "save-string" : "cancel-string";
      const canAdd = selectedClients.length > 0;
      const Save = async () => {
        if (canAdd) {
          toggleVariable();

          try {
            const copyPromises = selectedClients.map(async (clientId) => {
              const clientObject = nutritionPlan.coach.clients.find(
                (cli) => cli.id === clientId
              );
              if (clientObject) {
                await clientObject.copyNutritionPlanToClient(t, nutritionPlan);
              } else {
                console.error(`Client not found with ID: ${clientId}`);
                // Handle the case where the client object wasn't found
              }
            });

            // Wait for all copy operations to complete
            await Promise.all(copyPromises);

            // All operations completed successfully, you can safely close the modal or update the UI here
            // onClose();
          } catch (error) {
            console.error("Error copying block to clients:", error);
            // Handle any errors that occurred during the copy operations
          }
        }
      };

      const [isHovered, setIsHovered] = useState(false);

      return bool ? (
        <TouchableOpacity
          onPress={Save}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          disabled={!notBlocked}
        >
          <View
            style={{
              // marginHorizontal: 20,
              backgroundColor: Colors.bubbleColor,
              borderRadius: 14,
              borderWidth: 1,
              justifyContent: "center",
              borderColor: Colors.bubbleColor,
              width: 80,
              height: 35,
              justifyContent: "center",
              alignItems: "center",
              opacity: isHovered ? 0.8 : canAdd ? 1 : 0.5,
            }}
          >
            {!notBlocked ? (
              <CustomActivityIndicator large={false} white={true} />
            ) : (
              <Text
                style={{
                  textAlignVertical: "center",
                  textAlign: "center",
                  color: Colors.whiteColor,
                }}
              >
                {t(text)}
              </Text>
            )}
          </View>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          onPress={Cancel}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          disabled={!notBlocked}
        >
          <View
            style={{
              marginHorizontal: 10,
              backgroundColor: isHovered ? Colors.redColor : Colors.whiteColor,
              borderRadius: 14,
              borderWidth: 1,
              justifyContent: "center",
              borderColor: "red",
              width: 80,
              height: 35,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                textAlignVertical: "center",
                textAlign: "center",
                color: isHovered ? "white" : Colors.redColor,
              }}
            >
              {t(text)}
            </Text>
          </View>
        </TouchableOpacity>
      );
    };

    return (
      <Modal
        animationType="fade"
        transparent={true}
        visible={isVisible}
        onRequestClose={notBlocked && onClose}
      >
        <View style={GlobalStyles.centeredView}>
          <TouchableOpacity
            onPress={Cancel}
            style={GlobalStyles.touchableBackground}
            disabled={!notBlocked}
          >
            <View />
          </TouchableOpacity>
          <View
            style={{
              position: "absolute",
              alignItems: "center",
              justifyContent: "center",
            }}
            onStartShouldSetResponder={() => false}
          >
            <View
              style={[
                styles.modalView,
                {
                  maxWidth: screenSize === "small" ? 360 : 450,
                  width: "90%",
                  maxHeight: screenSize === "small" ? 450 : 600,
                  alignSelf: "center",
                },
              ]}
            >
              <SearchBar />
              <View
                style={{
                  marginTop: 10,
                  width: "100%",
                }}
              >
                <Text
                  style={{
                    color: Colors.grayColor,
                    fontWeight: "500",
                    marginLeft: 15,
                    marginBottom: 4,
                  }}
                >
                  {t("athletes-string")}
                </Text>
                <View
                  style={{
                    height: 0.5,

                    // backgroundColor: "rgba(255, 255, 255, 0.2)",
                    backgroundColor: Colors.grayColor,
                  }}
                />
              </View>
              <Observer>
                {() => (
                  <ScrollView
                    style={{
                      marginHorizontal: 0,
                      marginBottom: 0,
                      borderBottomLeftRadius: 14,
                      borderBottomRightRadius: 14,
                    }}
                    showsVerticalScrollIndicator={false}
                  >
                    {nutritionPlan.coach &&
                    nutritionPlan.coach
                      .getFilteredClients()
                      .filter((client) => client.status === "active-string")
                      .length > 0 ? (
                      <>
                        {nutritionPlan.coach
                          .getFilteredClients()
                          .filter((client) => client.status === "active-string")
                          .map((client, index) => (
                            <View key={client.id}>
                              <ClientRow client={client} index={index} />
                              {index <
                                nutritionPlan.coach
                                  .getFilteredClients()
                                  .filter(
                                    (client) =>
                                      client.status === "active-string"
                                  ).length -
                                  1 && (
                                <View
                                  style={{
                                    height: 0.5,
                                    // backgroundColor: "rgba(255, 255, 255, 0.2)",
                                    backgroundColor: Colors.grayColor,
                                    // marginHorizontal: 20,
                                  }}
                                />
                              )}
                            </View>
                          ))}
                      </>
                    ) : (
                      <>
                        <IconEmptyView
                          iconLibrary={"Ionicons"}
                          mainText={"emptyClientsTitle-string"}
                          subText={"noAthletesFoundText-string"}
                          iconName={"people-outline"}
                          marginTop={40}
                          marginBottom={8}
                        />
                      </>
                    )}
                  </ScrollView>
                )}
              </Observer>
            </View>
          </View>
        </View>
      </Modal>
    );
  };

  const PlanRow = observer(({ nutritionPlan }) => {
    const [showingDeleteAlert, setShowingDeleteAlert] = useState(false);
    const deleteAlertTitle = "deleteNutritionPlanAlertTitle-string";
    const deleteAlertText = "deleteNutritionPlanAlertText-string";

    const deletePlan = () => {
      coach.updateCoachDeletionNutritionPlans(nutritionPlan.id);
      coach.startOrResetBatchTimer();

      coach.setProperty(
        "nutritionPlans",
        (coach.nutritionPlans = coach.nutritionPlans.filter(
          (np) => np.id !== nutritionPlan.id
        ))
      );
    };

    const [showingCopyToClient, setShowingCopyToClient] = useState(false);

    const [competitionMenu, setCompetitionMenu] = useState(false);
    const showCompetitionMenu = () => setCompetitionMenu(true);

    const action = () => {
      coach.initAuxNutritionPlan(nutritionPlan);
      setShowingAddNutritionPlan(true);
    };

    const showDeleteAlert = () => {
      setShowingDeleteAlert(true);
      setCompetitionMenu(false);
    };

    const showEditCompetition = () => {
      coach.initAuxNutritionPlan(nutritionPlan);
      setShowingAddNutritionPlan(true);
      setCompetitionMenu(false);
    };

    const showCopyToClient = () => {
      setShowingCopyToClient(true);
      setCompetitionMenu(false);
    };

    const [isHovered, setIsHovered] = useState(false);

    const [isMenuHovered, setIsMenuHovered] = useState(false);

    const MenuItemView = ({ idx }) => {
      const [isHovered, setIsHovered] = useState(false);

      return idx === 1 ? (
        <MenuItem
          onPress={showCopyToClient}
          style={{ minWidth: 190 }}
          textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("copyToAClient-string")}
        </MenuItem>
      ) : (
        <MenuItem
          onPress={showDeleteAlert}
          style={{ minWidth: 150 }}
          textStyle={{
            fontSize: 14,
            color: "red",
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("delete-string")}
        </MenuItem>
      );
    };

    return (
      <View style={{ width: "100%" }}>
        <TouchableOpacity
          onPress={action}
          style={{
            backgroundColor: "white",
            borderRadius: 14,
            borderWidth: 0.1,
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: screenSize === "small" ? 12 : 15,
            paddingBottom: screenSize === "small" ? 12 : 15,
            paddingHorizontal: screenSize === "small" ? 12 : 15,
            marginBottom: screenSize === "small" ? 8 : 12,
            borderColor: isHovered ? "rgba(0, 0, 0, 0.5)" : Colors.borderColor,
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              height: screenSize !== "small" && 65,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <View
              style={{
                flexShrink: 1,
              }}
            >
              <Text
                numberOfLines={2}
                style={[
                  screenSize === "small" ? Fonts.medium14 : Fonts.medium16,
                  { width: "100%", marginBottom: 10, flexShrink: 1 },
                ]}
              >
                {nutritionPlan.name}
              </Text>
              <View
                style={[
                  GlobalStyles.HStack,
                  { width: "100%", flexWrap: "wrap" },
                ]}
              >
                <View style={[GlobalStyles.HStack]}>
                  <FontAwesome5
                    name="clipboard-list"
                    size={screenSize === "small" ? 12 : 14}
                    color={Colors.bubbleColor}
                    style={GlobalStyles.rowIcon}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                  >
                    {t("numberOfMeals-string", {
                      number: nutritionPlan.meals.length,
                    })}
                  </Text>
                </View>
                <View style={[GlobalStyles.HStack]}>
                  <FontAwesome5
                    name="bullseye"
                    size={screenSize === "small" ? 12 : 14}
                    color={Colors.bubbleColor}
                    style={GlobalStyles.rowIcon}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                  >
                    {nutritionPlan.caloriesGoal > 0
                      ? `${formatNumber(
                          nutritionPlan.getMacroTotal("calories")
                        )} / ${nutritionPlan.caloriesGoal}`
                      : `${formatNumber(
                          nutritionPlan.getMacroTotal("calories")
                        )}`}{" "}
                    kcal
                  </Text>
                </View>
                <View style={[GlobalStyles.HStack]}>
                  <View
                    style={[
                      GlobalStyles.rowIcon,
                      {
                        width: 12,
                        height: 12,
                        borderRadius: 50,
                        backgroundColor: Colors.carbsColor,
                      },
                    ]}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                  >
                    {formatNumber(nutritionPlan.getMacroTotal("carbs"))}
                    {"g "}
                    carbohidratos
                  </Text>
                </View>
                <View style={[GlobalStyles.HStack]}>
                  <View
                    style={[
                      GlobalStyles.rowIcon,
                      {
                        width: 12,
                        height: 12,
                        borderRadius: 50,
                        backgroundColor: Colors.proteinColor,
                      },
                    ]}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                  >
                    {formatNumber(nutritionPlan.getMacroTotal("protein"))}
                    {"g "}
                    proteína
                  </Text>
                </View>
                <View style={[GlobalStyles.HStack]}>
                  <View
                    style={[
                      GlobalStyles.rowIcon,
                      {
                        width: 12,
                        height: 12,
                        borderRadius: 50,
                        backgroundColor: Colors.fatsColor,
                      },
                    ]}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize === "small" ? 12 : 14,
                    }}
                  >
                    {formatNumber(nutritionPlan.getMacroTotal("fats"))}
                    {"g "}
                    grasas
                  </Text>
                </View>
              </View>
            </View>

            <Menu
              visible={competitionMenu}
              anchor={
                <TouchableOpacity
                  onPress={showCompetitionMenu}
                  onMouseEnter={() => !isMobile && setIsMenuHovered(true)}
                  onMouseLeave={() => setIsMenuHovered(false)}
                >
                  <Entypo
                    name="dots-three-horizontal"
                    size={screenSize === "small" ? 22 : 24}
                    color="black"
                    style={{
                      paddingVertical: screenSize === "small" ? 8 : 16,
                      paddingHorizontal: screenSize === "small" ? 0 : 16,
                      opacity: isMenuHovered ? 0.5 : 1,
                      marginLeft: screenSize === "small" ? 8 : 0,
                    }}
                  />
                </TouchableOpacity>
              }
              style={GlobalStyles.menu}
              onRequestClose={() => setCompetitionMenu(false)}
            >
              <MenuItemView idx={1} />
              <MenuItemView idx={2} />
            </Menu>
          </View>
        </TouchableOpacity>

        {showingCopyToClient && (
          <CopyNutritionPlanToClient
            isVisible={showingCopyToClient}
            onClose={() => setShowingCopyToClient(false)}
            nutritionPlan={nutritionPlan}
          />
        )}

        {showingDeleteAlert && (
          <CustomAlert
            isVisible={showingDeleteAlert}
            onClose={() => setShowingDeleteAlert(false)}
            title={deleteAlertTitle}
            text={deleteAlertText}
            action={deletePlan}
            specialCTA={"delete-string"}
          />
        )}
      </View>
    );
  });

  const NutritionPlanListView = observer(({ coach }) => {
    return (
      <View style={{}}>
        {coach &&
          coach.nutritionPlans &&
          coach.nutritionPlans.map((nutritionPlan, idx) => (
            <PlanRow nutritionPlan={nutritionPlan} key={idx} />
          ))}
      </View>
    );
  });

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: Colors.backgroundColor,
        marginTop: screenSize === "small" ? 16 : 24,
        // justifyContent: "flex-start",
      }}
    >
      <View
        style={[GlobalStyles.HStack, { marginBottom: 16, maxWidth: "60%" }]}
      >
        <SearchBar
          text={text}
          onChangeText={(text) => setText(text)}
          placeholder={t("search-string")}
        />

        <CTAButton
          plus={true}
          text={t("newPlan-string")}
          action={() => {
            coach.initAuxNutritionPlan();
            setShowingAddNutritionPlan(true);
          }}
          disabled={false}
        />
      </View>

      <NutritionPlanListView coach={coach} />

      {showingAddNutritionPlan && coach.auxNutritionPlan && (
        <AddNutritionPlanView
          isVisible={showingAddNutritionPlan}
          onClose={() => setShowingAddNutritionPlan(false)}
          nutritionPlan={coach.auxNutritionPlan}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  textInputStyle: {
    flex: 1,
    paddingHorizontal: 10,
    borderRadius: 14,
    borderWidth: 0,
    fontWeight: "400",
    fontSize: 14,
  },
  searchBar: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
    borderRadius: 14,
    height: 40,
  },
  modalView: {
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
});

export default CoachNutritionPlanLibrary;
